export const getNextMonthName = (needToIncline?: boolean) => {
  const now = new Date();
  const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  const monthName = nextMonth.toLocaleString('ru-RU', { month: 'long' });

  const monthGenitive: Record<string, string> = {
    'январь': 'января',
    'февраль': 'февраля',
    'март': 'марта',
    'апрель': 'апреля',
    'май': 'мая',
    'июнь': 'июня',
    'июль': 'июля',
    'август': 'августа',
    'сентябрь': 'сентября',
    'октябрь': 'октября',
    'ноябрь': 'ноября',
    'декабрь': 'декабря',
  };

  if (needToIncline) return monthGenitive[monthName] || monthName;

  return monthName
};
